import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import useGlobalSearchVerticalTabHotels from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabHotels'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import type { SupportedDestinations } from 'home/constants'
import { SUPPORTED_DESTINATION_IDS } from 'home/constants'
import { capitalise } from 'lib/string/stringUtils'
import React, { useEffect } from 'react'
import type { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router'
import { useIntl } from 'react-intl'

function MobileSearch({ match }: RouteComponentProps<{ destination: SupportedDestinations }>) {
  const intl = useIntl()
  const globalSearchVerticalTabHotels = useGlobalSearchVerticalTabHotels()
  const { context, ContentComponent: SearchElement, onSearch } = globalSearchVerticalTabHotels

  const { destination } = match.params
  const destinationId = SUPPORTED_DESTINATION_IDS[destination]

  // sync search item
  useEffect(() => {
    const searchItem: App.SearchItem = {
      searchType: 'destination',
      value: destinationId,
      format: {
        mainText: capitalise(destination),
      },
    };
    (context.dispatch as React.Dispatch<GlobalSearchAction>)({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem })
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [])

  return (
    <GlobalSearchContextProvider state={context.state as GlobalSearchState} dispatch={context.dispatch as React.Dispatch<GlobalSearchAction>}>
      <VerticalSpacer gap={12}>
        <SearchElement
          onSearch={onSearch}
          isInPage
        />
        <TextButton
          kind="primary"
          size="large"
          shape="square"
          fit="full-width"
          onClick={onSearch}
        >
          {intl.formatMessage({
            id: 'hNt7XngoWb',
            defaultMessage: 'Search',
            description: 'Search button text',
          })}
        </TextButton>
      </VerticalSpacer>
    </GlobalSearchContextProvider>
  )
}

export default withRouter(MobileSearch)
